import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function oxygenSaturationEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/life_id-saturation.svg').default,
    title: 'life_id.saturation',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.oxygenSaturation) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.oxygenSaturation];
  const lastRecord = vitalData.oxygenSaturation.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'OXYGEN_SATURATION' as const,
    isEmpty: false,
    average: vitalData.oxygenSaturation.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.OXYGEN_SATURATION.valueSelectors[0] as keyof TVitalDataSearchItem,
      true,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: config.OXYGEN_SATURATION.unit as string,
      value: lastRecord.oxygenSaturation || '-',
      // FIXME: add one sided type in chart
      ...getGraphData(settings, [lastRecord.oxygenSaturation]),
    },
    urlPart: config.OXYGEN_SATURATION.urlPart,
  };
}
